import { handleActions } from "redux-actions";
import _orderBy from "lodash/orderBy";

const initState = {
  isFetchingProducts: false,
  isFetchingProductById: false,
  isFetchedProductById: false,
  productsMap: null,
  createProductError: null,

  isSelectingProducts: false,
  selectedProducts: null,

  isFetchingProductPhases: false,
  productPhaseMap: {},

  isCreatingProduct: false,
  isCreatedProduct: false,
  isUpdatingProduct: false,
  isUpdatedProduct: false,
  isUpdatingProductVersions: false,
  isUpdatedProductVersions: false,
  isUpdatingProductPhases: false,
  isUpdatedProductPhases: false,
  isDeletingProduct: false,
  isDeletedProduct: false,
};

const reducer = handleActions(
  {
    // reset product status
    REQUESTED_RESET_PRODUCT_STATUS: (state) => {
      const newState = {
        ...state,
        isCreatingProduct: false,
        isCreatedProduct: false,
        isUpdatingProduct: false,
        isUpdatedProduct: false,
        isUpdatingProductVersions: false,
        isUpdatedProductVersions: false,
        isUpdatingProductPhases: false,
        isUpdatedProductPhases: false,
        isDeletingProduct: false,
        isDeletedProduct: false,
      };
      return newState;
    },
    // GET Products Actions
    REQUESTED_PRODUCTS: (state) => ({
      ...state,
      isFetchingProducts: true,
      isUpdatedProductPhases: false,
    }),
    RECEIVED_PRODUCTS: (state, action) => {
      const newState = {
        ...state,
      };
      newState.isFetchingProducts = false;
      newState.isCreatedProduct = false;
      newState.productsMap =
        action.payload.products &&
        action.payload.products.reduce((obj, item) => {
          item.versions = _orderBy(item.versions, ["weight"], ["desc"]);
          item.versions = item.versions.map((version) => {
            let extra_headers = _orderBy(version.product_extra_headers, ["id"], ["asc"]);
            version.extra_header_values = extra_headers.map((item) => {
              let extra_header_value = {
                id: item.version_extra_dependences.id,
                header_id: item.id,
                extra_header: item.header,
                extra_value: item.version_extra_dependences.dependence_value
              };
              return extra_header_value;
            });
            delete version.product_extra_headers;
            return version;
          });

          obj[item.name] = {
            ...item,
            isFetchingProduct: false,
          };
          return obj;
        }, {});

      //TODO: default selectedProducts should related to user's profile setting
      newState.selectedProducts = ["Red Hat Enterprise Linux"];
      return newState;
    },
    REQUESTED_PRODUCT_BY_NAME: (state, action) => {
      const newState = {
        ...state,
      };
      if (newState.productsMap) {
        newState.productsMap[action.payload.name] = {
          isFetchingProduct: true,
        };
      }
      return newState;
    },
    RECEIVED_PRODUCT_BY_NAME: (state, action) => {
      const newState = {
        ...state,
      };
      if (newState.productsMap) {
        newState.productsMap[action.payload.product.name] = {
          ...action.payload.product,
          isFetchingProduct: false,
        };
      }
      return newState;
    },
    REQUESTED_PRODUCT_BY_ID: (state, action) => {
      const newState = {
        ...state,
        isFetchingProductById: true,
        isFetchedProductById: false,
      };
      if (newState.productsMap) {
        Object.keys(newState.productsMap).forEach((key) => {
          if (newState.productsMap[key].id === action.payload.id) {
            newState.productsMap[key].isFetchingProduct = true;
          }
        });
      }
      return newState;
    },
    RECEIVED_PRODUCT_BY_ID: (state, action) => {
      const newState = {
        ...state,
        isFetchingProductById: false,
        isFetchedProductById: true,
      };
      if (newState.productsMap) {
        action.payload.product.versions = _orderBy(
          action.payload.product.versions,
          ["weight"],
          ["desc"]
        );
        Object.keys(newState.productsMap).forEach((key) => {
          if (newState.productsMap[key].id === action.payload.product.id) {
            newState.productsMap[key] = {
              ...action.payload.product,
              isFetchingProduct: false,
            };
          }
        });
      }
      return newState;
    },

    // Product Phases Actions
    REQUESTED_PRODUCT_PHASES: (state) => ({
      ...state,
      isFetchingProductPhases: true,
      productPhaseMap: {},
    }),
    RECEIVED_PRODUCT_PHASES: (state, action) => {
      const newState = {
        ...state,
        isFetchingProductPhases: false,
      };
      newState.productPhaseMap[action.payload.name] =
        action.payload.productPhases;
      return newState;
    },

    // Selected Products Actions
    REQUESTED_SELECT_PRODUCT: (state) => ({
      ...state,
      isSelectingProducts: true,
    }),
    RECEIVED_SELECT_PRODUCT: (state, action) => {
      const newState = {
        ...state,
        isSelectingProducts: false,
        selectedProducts: action.payload.selectedProducts,
      };
      return newState;
    },

    // Create Product Actions
    REQUESTED_CREATE_PRODUCT: (state) => ({
      ...state,
      isCreatingProduct: true,
      isCreatedProduct: false,
    }),
    RECEIVED_CREATE_PRODUCT: (state, action) => {
      const newState = {
        ...state,
        isCreatingProduct: false,
        isCreatedProduct: true,
      };
      if (
        newState.productsMap &&
        action.payload.product &&
        action.payload.product.name
      ) {
        newState.productsMap[action.payload.product.name] =
          action.payload.product;
      }
      return newState;
    },

    // Update Product Actions
    REQUESTED_UPDATE_PRODUCT: (state) => ({
      ...state,
      isUpdatingProduct: true,
      isUpdatedProduct: false,
    }),
    RECEIVED_UPDATE_PRODUCT: (state, action) => {
      const newState = {
        ...state,
        isUpdatingProduct: false,
        isUpdatedProduct: true,
      };
      if (
        newState.productsMap &&
        action.payload.product &&
        action.payload.product.name
      ) {
        action.payload.product.versions = _orderBy(
          action.payload.product.versions,
          ["weight"],
          ["desc"]
        );
        newState.productsMap[action.payload.product.name] =
          action.payload.product;
      }
      return newState;
    },

    // Update Product Versions Actions
    REQUESTED_UPDATE_PRODUCT_VERSIONS: (state) => ({
      ...state,
      isUpdatingProductVersions: true,
      isUpdatedProductVersions: false,
    }),

    REQUESTED_CURRENT_PRODUCT_FAILED: (state, action) => ({
        ...state,
        isCreatingProduct: false,
        createProductError: action.payload && action.payload.error,
    }),

    RECEIVED_UPDATE_PRODUCT_VERSIONS: (state, action) => {
      const newState = {
        ...state,
        isUpdatingProductVersions: false,
        isUpdatedProductVersions: true,
      };
      if (
        newState.productsMap &&
        action.payload.product &&
        action.payload.product.name
      ) {
        action.payload.product.versions = _orderBy(
          action.payload.product.versions,
          ["weight"],
          ["desc"]
        );
        newState.productsMap[action.payload.product.name] =
          action.payload.product;
      }
      return newState;
    },

    // Update Product Phases Actions
    REQUESTED_UPDATE_PRODUCT_PHASES: (state) => ({
      ...state,
      isUpdatingProductPhases: true,
      isUpdatedProductPhases: false,
    }),
    RECEIVED_UPDATE_PRODUCT_PHASES: (state, action) => {
      const newState = {
        ...state,
        isUpdatingProductPhases: false,
        isUpdatedProductPhases: true,
      };
      if (
        newState.productsMap &&
        action.payload.product &&
        action.payload.product.name
      ) {
        action.payload.product.versions = _orderBy(
          action.payload.product.versions,
          ["weight"],
          ["desc"]
        );
        newState.productsMap[action.payload.product.name] =
          action.payload.product;
      }
      return newState;
    },

    // Delete Product
    REQUESTED_DELETE_PRODUCT: (state) => ({
      ...state,
      isDeletingProduct: true,
      isDeletedProduct: false,
    }),
    RECEIVED_DELETE_PRODUCT: (state, action) => {
      const newState = {
        ...state,
        isDeletingProduct: false,
        isDeletedProduct: true,
      };
      if (
        newState.productsMap &&
        action.payload.product &&
        action.payload.product.name
      ) {
        delete newState.productsMap[action.payload.product.name];
      }
      return newState;
    },

    // Delete product's version
    REQUESTED_DELETE_VERSION: (state) => ({
      ...state,
    }),
    RECEIVED_DELETE_VERSION: (state, action) => {
      const newState = {
        ...state,
        productsMap: null,
      };
      return newState;
    },
  },
  initState
);

export default reducer;
